import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAdditionalDescriptionText, useMainDescriptionText, } from "@/components/Sections/Description";
import { Description } from "@/components/Sections/Description/Description";
import { DescriptionCTA } from "@/components/Sections/Description/DescriptionCTA";
import { Section } from "@/components/UI";
import { useRefsContext } from "@/contexts/ref";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { Statistics } from "./Statistics/Statistics";
import { getFeaturesEnabled } from "@/utils/getFeaturesEnabled";
export const mainDescriptionTestId = "cdp-main-description";
export const MainDescription = () => {
    const MIN_DESCRIPTION_LENGTH = 20;
    const { t } = useI18n();
    const { headline, text } = useMainDescriptionText();
    const { text: additionalDescriptionText } = useAdditionalDescriptionText();
    const { descriptionRef } = useRefsContext();
    const title = t("description.modal.title");
    const shouldDisplayCta = text.length + additionalDescriptionText.length < MIN_DESCRIPTION_LENGTH;
    const { classifiedStats } = getFeaturesEnabled();
    return (_jsxs(Section, { unsafeClassname: "Description", ref: descriptionRef, children: [_jsx(Description, { avZone: "classified_description", testId: mainDescriptionTestId, headline: headline, text: text, title: title }), shouldDisplayCta && (_jsx(Box, { marginTop: "spacing.16", children: _jsx(DescriptionCTA, {}) })), classifiedStats && _jsx(Statistics, {})] }));
};
